
// https://github.com/mariocasciaro/object-path/blob/master/index.js
function initObjectPathGet() {

  var options = {
    includeInheritedProps: true,
  };

  function getKey(key) {
    var intKey = parseInt(key);
    if (intKey.toString() === key) {
      return intKey;
    }
    return key;
  }

  function hasOwnProperty(obj, prop) {
    if (obj == null) {
      return false
    }
    //to handle objects with null prototypes (too edge case?)
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }

  function hasShallowProperty(obj, prop) {
    return (options.includeInheritedProps || (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop))
  }

  function getShallowProperty(obj, prop) {
    if (hasShallowProperty(obj, prop)) {
      return obj[prop];
    }
  }

  function get(obj, path, defaultValue) {
    if (typeof path === 'number') {
      path = [path];
    }
    if (!path || path.length === 0) {
      return obj;
    }
    if (obj == null) {
      return defaultValue;
    }
    if (typeof path === 'string') {
      return get(obj, path.split('.'), defaultValue);
    }

    var currentPath = getKey(path[0]);
    var nextObj = getShallowProperty(obj, currentPath);
    if (nextObj === void 0) {
      return defaultValue;
    }

    if (path.length === 1) {
      return nextObj;
    }

    return get(obj[currentPath], path.slice(1), defaultValue);
  }

  return get;
}

// https://github.com/ivantsov/redux-subscriber/blob/master/src/index.js
export function initReduxSubscriber() {

  const subscribers = {};
  const get = initObjectPathGet();

  function subscribe(key, cb) {
    if (subscribers.hasOwnProperty(key)) {
      subscribers[key].push(cb);
    } else {
      subscribers[key] = [cb];
    }

    // return "unsubscribe" function
    return function() {
      subscribers[key] = subscribers[key].filter(s => s !== cb);
    };
  }

  function initSubscriber(store) {
    let prevState = store.getState();

    store.subscribe(() => {
      const newState = store.getState();

      Object.keys(subscribers).forEach(key => {
        if (get(prevState, key) !== get(newState, key)) {
          subscribers[key].forEach(cb => cb(newState));
        }
      });

      prevState = newState;
    });

    return subscribe;
  }

  return initSubscriber;
}
